/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// import * as Msdyn365 from '@msdyn365-commerce/core';

import { AsyncResult } from '@msdyn365-commerce/retail-proxy/dist/async-result';
import { DataServiceQuery } from '@msdyn365-commerce/retail-proxy/dist/DataServiceQuery';
// import { SalesOrder } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import { IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy/dist/interfaces';
import { executeAction } from '@msdyn365-commerce/retail-proxy/dist/retail-action';

function rrDataQuery(id?: string): DataServiceQuery {
    var key = id ? { Id: id } : null;
    return new DataServiceQuery('', '', '', key);
}

export function getOnlineStoreTransactionOrderAsync(
    context: IContext,
    transactionId: string
): AsyncResult<GetOnlineStoreTransactionSalesOrder> {
    const request = createGetOnlineStoreTransactionOrderInput(transactionId);
    return executeAction<GetOnlineStoreTransactionSalesOrder>(request, context);
}

export function createGetOnlineStoreTransactionOrderInput(transactionId: string): IDataServiceRequest {
    const query = rrDataQuery();
    return query.createDataServiceRequestForOperation(
        'GetOnlineStoreTransactionOrder',
        false,
        'GetOnlineStoreTransactionSalesOrder',
        'false',
        { bypassCache: 'get', returnEntity: 'IGetOnlineStoreTransactionOrderResponse' },
        { transactionId: transactionId }
    );
}

// TODO: Create a data model here or import one to capture the response of the action
export interface GetOnlineStoreTransactionSalesOrder {
    Id: number;
    SalesOrderId: string;
    ErrorData: string;
    ErrorMessage: string;
}

export interface PsOnlineStoreTransactionError {
    DATAAREAID: string;
    Channel: string;
    Store: string;
    TransactionId: string;
    ProcessorType: number;
    ErrorData: string;
}
